import { Input, MenuItem, OutlinedInput, Select, SelectChangeEvent } from "@mui/material";
import { CustomFloatingFilterProps } from "ag-grid-react";
import React, { useState } from "react";
import { inputProps, MenuProps, OutlinedInputProps } from "../../components/muiStyles/muiInput";
import { InputPicker } from "rsuite";

interface FilterDropdownProps extends CustomFloatingFilterProps {
    options: string[];
}

const CustomSelectFilter = (props: FilterDropdownProps) => {
    const { options, column, api } = props;
    const [selectedValue, setSelectedValue] = useState<string | null>(null);
    const onChange = (val: string | null) => {
        if (val == '-1')
            return cleanHandle();

        setSelectedValue(val);
        // AG Grid v34+: model фильтра колонки задаётся через grid API
        api.setColumnFilterModel(column, val ? { filter: val, type: 'equals' } : null)
            .then(() => api.onFilterChanged()); // Применяем фильтр после установки модели
    };
    const cleanHandle = () => {
        onChange(null);
    }
    return (
        <InputPicker
            style={{ width: '100%' }}
            data={options.map(opt => ({ label: opt, value: opt }))}
            value={selectedValue}
            onChange={onChange}
            onClean={cleanHandle}
            size='sm'
        />
    );
};

export default CustomSelectFilter;